module.exports = __webpack_public_path__ + "f9e1b6d07386650d932194865f8c1ef4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-old-man.png
// module id = 2444
// module chunks = 0